import OpenAI from "openai";

// OpenAI-Konfiguration
const openai = new OpenAI({
  organization: "org-0ulzEVmmNmDzdvUW3Dz2pLzg",
  apiKey: process.env.REACT_APP_OPENAI_API_KEY,
  dangerouslyAllowBrowser: true
});

// Funktion: Datei hochladen und `file_id` zurückgeben
const uploadFile = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("purpose", "image");

    const response = await openai.files.create({
      file: file,
      purpose: "vision",
    });

    return response; // Gibt die `file_id` zurück
  } catch (error) {
    console.error("Fehler beim Hochladen der Datei:", error);
    throw new Error(error.message || "File upload failed.");
  }
};

// Funktion: Bild analysieren
export const analyzeImage = async (file) => {
  const thread = await openai.beta.threads.create();

  try {
    // 1. Datei hochladen und `file_id` abrufen
    const uploadedFile = await uploadFile(file);

    // 2. Bildanalyse durchführen
    const message = await openai.beta.threads.messages.create(thread.id, {
      role: "user",
      content: [
        {
          type: "image_file",
          image_file: { file_id: uploadedFile.id }, // `file_id` verwenden
        },
      ],
    });
    
    const run = await openai.beta.threads.runs.createAndPoll(thread.id, {
      assistant_id: process.env.REACT_APP_IMAGE_ASSISTANT_ID //assistant.id,
    });

    if (run.status === "completed") {
      const messages = await openai.beta.threads.messages.list(run.thread_id);
      return messages.data[0].content[0].text.value;
    } else {
      console.log(run.status);
    }
  } catch (error) {
    console.error("Fehler bei der Analyse:", error);
    throw new Error(error.message || "Image analysis failed.");
  }
};

// **Neue Funktion**: Beschreibung zu JSON konvertieren
export const generateCardJson = async (description) => {
  try {
    // Assistenten-Thread erstellen
    const newThread = await openai.beta.threads.create({
      tool_resources: {
        "file_search": {
          "vector_store_ids": ["vs_ZgTaQGqGXIOnLasGjOUjOYaD"]
        }
      }
    });

    // Nachricht mit der Beschreibung senden
    await openai.beta.threads.messages.create(newThread.id, {
      role: "user",
      content: [
        {
          type: "text",
          text: description,
        },
      ],
    });

    // JSON-Erstellung durch den neuen Assistenten starten
    const run = await openai.beta.threads.runs.createAndPoll(newThread.id, {
      assistant_id: process.env.REACT_APP_CARD_ASSISTANT_ID, // Assistent für JSON-Erstellung
    });

    if (run.status === "completed") {
      const messages = await openai.beta.threads.messages.list(run.thread_id);
      return myJSONparser(messages.data[0].content[0].text.value); // JSON-Antwort zurückgeben
    } else {
      console.error("JSON-Erstellung fehlgeschlagen:", run.status);
      throw new Error("JSON creation failed.");
    }
  } catch (error) {
    console.error("Fehler beim Generieren des JSONs:", error);
    throw new Error(error.message || "JSON generation failed.");
  }
};

const myJSONparser = (str) => {
  if (str.includes("```json")) {
    str = str.substring(
      str.indexOf("```json") + 7, 
      str.lastIndexOf("```")
    );
  }
  return JSON.parse(str);
}